import { render, staticRenderFns } from "./List-ContactUs.vue?vue&type=template&id=af23b440&scoped=true"
import script from "./List-ContactUs.vue?vue&type=script&lang=js"
export * from "./List-ContactUs.vue?vue&type=script&lang=js"
import style0 from "./List-ContactUs.vue?vue&type=style&index=0&id=af23b440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af23b440",
  null
  
)

export default component.exports